import { render } from "./Vehicle.vue?vue&type=template&id=3f196a9c&scoped=true&bindings={}"
import script from "./Vehicle.vue?vue&type=script&lang=ts"
export * from "./Vehicle.vue?vue&type=script&lang=ts"

import "./Vehicle.vue?vue&type=style&index=0&id=3f196a9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f196a9c"

export default script